function privacyPopupInit(localStorageKey, localStorageValue) {
	if (localStorage.getItem(localStorageKey) !== localStorageValue) {
		const activeClass = 'is-visible';
		const popup = document.querySelector('#privacy-pop-up');
		const closeBtns = document.querySelectorAll('.privacy-pop-up__button');
		popup.classList.add(activeClass);
		closeBtns.forEach((closeBtn) => {
			closeBtn.addEventListener(
				'click',
				() => {
					localStorage.setItem(localStorageKey, localStorageValue);
					popup.classList.remove(activeClass);
				},
				{ once: true },
			);
		});
	}
}
